import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  modal: {
    position: 'absolute',
    zIndex: 3,
    top: '6rem',
    left: 0,
    width: '40rem',
    maxHeight: '55rem',
    backgroundColor: colors.neutral.white,
    borderRadius: '0.6rem',
    boxShadow: '0rem 0.4rem 0.8rem rgba(0, 0, 0, 0.14)',
  },
  productLineSectionWrapper: {
    overflowY: 'auto',
    maxHeight: '40rem',
  },
  show: {
    display: 'block',
  },
  hide: {
    display: 'none',
  },
  applyPlansText: {
    textAlign: 'center',
    fontSize: '1.6rem',
    fontWeight: '400',
    margin: 0,
    paddingTop: '2.4rem',
    paddingBottom: '1.6rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
  },
  employeesCount: {
    color: colors.green[600],
    fontWeight: '700',
  },
  plansSection: {
    textTransform: 'capitalize',
  },
  productLineNameWrapper: {
    padding: '2.6rem 2rem 1rem',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
  },
  productLineName: {
    fontSize: '1.8rem',
    marginLeft: '0.8rem',
  },
  plansWrapper: {
    padding: '0 3.5rem',
  },
  plan: {
    '& label': {
      cursor: 'pointer',
    },
    padding: '1.6rem 0',
    borderBottom: `0.1rem solid ${colors.neutral[200]}`,
  },
  selectedPlan: {
    '& svg': {
      fill: colors.blue[600],
    },
  },
  notSelectedPlan: {
    '& svg': {
      fill: colors.neutral[400],
    },
    '& span': {
      color: colors.neutral[400],
    },
  },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    padding: '2.4rem',
    borderTop: `0.1rem solid ${colors.neutral[200]}`,
  },
  actionBtn: {
    padding: '0rem 5rem',
  },
  cancelBtn: {
    padding: '0rem 5rem',
    marginRight: '2rem',
  },
  cancelWarningModalBtn: {
    margin: '3rem 0',
    padding: '0rem 5rem',
  },
  differentClassesBtn: {
    margin: '2rem 0 3rem',
  },
  warningText: {
    fontSize: '1.8rem',
    lineHeight: '2.4rem',
    maxWidth: '23.8rem',
    textAlign: 'center',
    marginTop: '3.5rem',
    marginBottom: '3rem',
    textTransform: 'none',
    letterSpacing: '0.02em',
  },
  differentClassesText: {
    margin: '1.2rem 0 2rem',
  },
  icon: {
    marginTop: '3rem',
  },
  warningContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
};
const createStyles = createUseStyles(styles);

export { createStyles };
